<template>
  <div class="row">
    <div v-if="visibleAds.length !== 0" class="notice-list mb-3">
      <transition-group name="notice-fade" tag="div">
        <div
          v-for="ads in visibleAds"
          :key="ads.id ?? ads.ads_text"
          :class="['notice-card', `notice-card-${ads.ads_type}`]"
          role="alert"
        >
          <span class="notice-card-icon">
            <i :class="adsIcon(ads.ads_type)"></i>
          </span>
          <div class="notice-card-body" v-html="ads.ads_text"></div>
          <button
            type="button"
            class="notice-card-close"
            aria-label="Close"
            @click="dismissAd(ads)"
          >
            <i class="flaticon-close"></i>
          </button>
        </div>
      </transition-group>
    </div>
  </div>
  <div class="row">
    <!-- <div class="col-lg-6 col-xxxl-6 col-md-6">
          <ExpectedEarnings />
        </div>
        <div class="col-lg-6 col-xxxl-6 col-md-6">
          <AverageDailySales />
        </div> -->
    <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white monthly-revenue-box">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span
            class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis"
          >
            REVENUE NET <small>(DH)</small>
          </span>
          <h4 class="fw-black mb-12 lh-1">{{ dashData?.NetRevenue || 0 }}</h4>
        </div>
      </div>
    </div>
    <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white monthly-new-customers-box"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="title">
            <span
              class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis"
            >
              TOTAL COLIS
            </span>
            <h4 class="fw-black mb-12 lh-1">
              {{ dashData?.Parcels?.totalparcels || 0 }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- <button
      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
      type="button"
      v-on="{ click: handleLogin }"
    >
      Sign In Now
    </button> -->

    <StatsBoxes :dashData="dashData" />

    <!-- <div class="col-xxl-4">
      <SalesByPOSLocation />
    </div>
    <div class="col-xxl-4">
      <TopSellingProducts />
    </div>
    <div class="col-xxl-4">
      <WebsiteVisitors />
    </div> -->
    <!-- <div class="col-xxl-6">
      <ProductsOrders />
    </div>
    <div class="col-xxl-6">
      <StockReport />
    </div> -->
  </div>
  <div class="row">
    <!-- sttauts data -->
    <div class="col-lg-6">
      <div
        class="card mb-25 border-0 rounded-0 letter-spacing courses-list-box"
      >
        <div class="card-body">
          <div class="title position-relative mb-12 mb-md-12">
            <div
              class="icon text-center rounded-circle position-relative bg-primary"
            >
              <div
                class="icon position-relative rounded-circle text-center text-white"
              >
                <i
                  class="flaticon-sterile-box"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 64px;
                    height: 60px;
                    font-size: 32px;
                  "
                ></i>
              </div>
            </div>
            <h6 class="mb-0 text-black fw-bold">
              Colis Livrés
              <b>
                ({{
                  sum(
                    dashData?.Parcels?.deliveredparcelsinvoiced,
                    dashData?.Parcels?.deliveredparcelsnotinvoiced
                  )
                }})</b
              >
            </h6>
          </div>

          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.deliveredparcelsinvoiced }}
              </span>
              Colis Facturé <br />
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.deliveredparcelsnotinvoiced }}
              </span>
              Colis Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.totalcrbtdelivredinvoiced }}
              </span>
              Crbt Facturé <br />
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.totalcrbtdelivrednotinvoiced }}
              </span>
              Crbt Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.totalfeesdelivredinvoiced }}
              </span>
              Frais Facturé <br />
              <span class="fw-bold text-primary">
                {{ dashData?.Parcels?.totalfeesdelivrednotinvoiced }}
              </span>
              Frais Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-primary">
                <b>{{ dashData?.Parcels?.totalofalldelivered }}</b>
              </span>
              Total
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div
        class="card mb-25 border-0 rounded-0 letter-spacing courses-list-box"
      >
        <div class="card-body">
          <div class="title position-relative mb-12 mb-md-12">
            <div
              class="icon text-center rounded-circle position-relative bg-warning"
            >
              <div
                class="icon position-relative rounded-circle text-center text-white"
              >
                <i
                  class="flaticon-sterile-box"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 64px;
                    height: 60px;
                    font-size: 32px;
                  "
                ></i>
              </div>
            </div>
            <h6 class="mb-0 text-black fw-bold">
              Colis Refusés
              <b>
                ({{
                  sum(
                    dashData?.Parcels?.refuseparcelsinvoiced,
                    dashData?.Parcels?.refuseparcelsnotinvoiced
                  )
                }})</b
              >
            </h6>
          </div>

          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.refuseparcelsinvoiced }}
              </span>
              Colis Facturé <br />
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.refuseparcelsnotinvoiced }}
              </span>
              Colis Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.totalcrbtrefuseinvoiced }}
              </span>
              Crbt Facturé <br />
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.totalcrbtrefusednotinvoiced }}
              </span>
              Crbt Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.totalfeesrefuseinvoiced }}
              </span>
              Frais Facturé <br />
              <span class="fw-bold text-warning">
                {{ dashData?.Parcels?.totalfeesrefusenotinvoiced }}
              </span>
              Frais Non Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-warning">
                <b>{{ dashData?.Parcels?.totalofallrefuse }}</b>
              </span>
              Total
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div
        class="card mb-25 border-0 rounded-0 letter-spacing courses-list-box"
      >
        <div class="card-body">
          <div class="title position-relative mb-12 mb-md-12">
            <div
              class="icon text-center rounded-circle position-relative bg-danger"
            >
              <div
                class="icon position-relative rounded-circle text-center text-white"
              >
                <i
                  class="flaticon-sterile-box"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 64px;
                    height: 60px;
                    font-size: 32px;
                  "
                ></i>
              </div>
            </div>
            <h6 class="mb-0 text-black fw-bold">
              Colis Retournés
              <b> ({{ dashData?.Parcels?.returnedparcels }})</b>
            </h6>
          </div>

          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-danger">
                {{ dashData?.Parcels?.returnedparcels }}
              </span>
              Colis Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-danger">
                {{ dashData?.Parcels?.totalcrbtreturned }}
              </span>
              Crbt Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-danger">
                {{ dashData?.Parcels?.totalfeesretunred }}
              </span>
              Frais Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-danger">
                <b>{{ dashData?.Parcels?.totalofallretunred }}</b>
              </span>
              Total
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div
        class="card mb-25 border-0 rounded-0 letter-spacing courses-list-box"
      >
        <div class="card-body">
          <div class="title position-relative mb-12 mb-md-12">
            <div
              class="icon text-center rounded-circle position-relative bg-success"
            >
              <div
                class="icon position-relative rounded-circle text-center text-white"
              >
                <i
                  class="flaticon-sterile-box"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 64px;
                    height: 60px;
                    font-size: 32px;
                  "
                ></i>
              </div>
            </div>
            <h6 class="mb-0 text-black fw-bold">
              Colis En Cours
              <b> ({{ dashData?.Parcels?.inprogressparcels }})</b>
            </h6>
          </div>

          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-success">
                {{ dashData?.Parcels?.inprogressparcels }}
              </span>
              Colis Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-success">
                {{ dashData?.Parcels?.totalcrbtinprogress }}
              </span>
              Crbt Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-success">
                {{ dashData?.Parcels?.totalfeesinprogress }}
              </span>
              Frais Facturé
            </li>
            <li class="d-inline-block bg-white fs-13 text-muted fw-medium">
              <span class="fw-bold text-success">
                <b>{{ dashData?.Parcels?.totalofallinProgress }}</b>
              </span>
              Total
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <ChartCitieStatistics />
    </div>
    <div class="col-lg-6">
      <DonutStatusChart />
    </div>
   <div class="col-lg-12"  v-if="perms.stock === 1" >
      <TopProductStock />
    </div>

   <!--  <div class="col-lg-12" v-if="perms.self_stock === 1">
      <top-product-own-stock :devis="devise" />
    </div>

    <div class="col-lg-12">
      <stores-donut />
    </div> -->
  </div>

  <!-- <div class="row">
    <WeeklySales />
  </div> -->
</template>

<script lang="ts">
import { defineComponent } from "vue";

// import WhatHappening from "../../components/Dashboard/Ecommerce/WhatHappening.vue";

// import ExpectedEarnings from "../../components/Dashboard/Ecommerce/ExpectedEarnings.vue";

// import AverageDailySales from "../../components/Dashboard/Ecommerce/AverageDailySales.vue";

import RevenueThisMonth from "../../components/Dashboard/Ecommerce/RevenueThisMonth.vue";

import NewCustomersThisMonth from "../../components/Dashboard/Ecommerce/NewCustomersThisMonth.vue";

import StatsBoxes from "../../components/Dashboard/Ecommerce/StatsBoxes/index.vue";

import WeeklySales from "../../components/Dashboard/Ecommerce/WeeklySales.vue";

import SalesByPOSLocation from "../../components/Dashboard/Ecommerce/SalesByPOSLocation.vue";

import TopSellingProducts from "../../components/Dashboard/Ecommerce/TopSellingProducts/index.vue";

import WebsiteVisitors from "../../components/Dashboard/Ecommerce/WebsiteVisitors.vue";

import ProductsOrders from "../../components/Dashboard/Ecommerce/ProductsOrders/index.vue";

import StockReport from "../../components/Dashboard/Ecommerce/StockReport/index.vue";

import ChartCitieStatistics from "../../components/Dashboard/Ecommerce/ChartCitieStatistics.vue";
import DonutStatusChart from "../../components/Dashboard/Ecommerce/DonutStatusChart.vue";
import TopProductStock from "../../components/Dashboard/Ecommerce/TopProductStock.vue";


import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";
import { ref, computed } from "vue";
import { onMounted } from "vue";

export default defineComponent({
  name: "EcommercePage",
  components: {
    // ExpectedEarnings,
    // AverageDailySales,
    // RevenueThisMonth,
    // NewCustomersThisMonth,
    StatsBoxes,
    // WeeklySales,
    // SalesByPOSLocation,
    // TopSellingProducts,
    // WebsiteVisitors,
    // ProductsOrders,
    // StockReport,
    ChartCitieStatistics,
    DonutStatusChart,
    TopProductStock
  },

  setup() {
    const auth = useAuthStore();

    // Any setup logic can go here
    const handleLogin = async () => {
      // console.log(localStorage.getItem("authToken"));
      // console.log("User data:", auth.token, auth.user);
      // const res = await api.get("/api/auth/SituationColis");
      // console.log("Situation Colis:", res.data);
    };
    let perms = ref<any>({});
    perms.value = auth.permissions || {};
    // console.log("User permissions:", perms.value);

    // Declare your variables using ref
    const dashData = ref<any>({});
    const searchEDate = ref("");
    const searchSDate = ref("");
    const adsData = ref([]);
    const dismissedAdIds = ref(new Set());
    const visibleAds = computed(() =>
      adsData.value.filter(
        (ads: any) => !dismissedAdIds.value.has(ads.id ?? ads.ads_text)
      )
    );
    function dismissAd(ads: any) {
      dismissedAdIds.value.add(ads.id ?? ads.ads_text);
    }
    function adsIcon(type: string) {
      switch (type) {
        case "success":
          return "flaticon-check";
        case "danger":
          return "flaticon-warning";
        case "warning":
          return "flaticon-bell";
        default:
          return "flaticon-info";
      }
    }
    const sow_rib = ref(false);
    const modal_show = ref(false);
    const bankList = ref([]);
    const bank = ref({});
    const rib = ref("");
    const devise = ref("DH");
    const isLoader = ref(true);
    const dataparcels = ref({});

    onMounted(async () => {
      fetchAds();
      getData();
    });
    async function fetchAds() {
      try {
        const response = await api.get("/api/auth/client/show_ads");
        adsData.value = response.data || [];
        console.log("Ads fetched:", adsData.value);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    }

    // Converts a date to the required format
    function convert(date: string | Date) {
      // Implement your date conversion logic here
      // Example: return new Date(date).toISOString().split('T')[0];
      return date ? new Date(date).toISOString().split("T")[0] : "";
    }

    // Fetch dashboard statistics data
    async function getData() {
      isLoader.value = true;
      try {
        const response = await api.get(
          `/api/auth/client/Statistic?searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        );
        // You may want to define DashData as a ref if you use it elsewhere
        dashData.value = response.data;
      } catch (error) {
        // You may want to define error as a ref if you use it elsewhere
        // error.value = true;
        console.error(error);
      } finally {
        isLoader.value = false;
      }
    }

    // Filter dashboard data based on date range
    function FilterData() {
      // You need to define myInput as a ref and bind it to your input component
      const myInput = (this as any).$refs?.myInput;
      searchSDate.value = myInput?.dateRange?.start
        ? convert(myInput.dateRange.start)
        : "";
      searchEDate.value = myInput?.dateRange?.end
        ? convert(myInput.dateRange.end)
        : "";
      getData();
    }

    // Clear filters and reload dashboard data
    function ClearFilterData() {
      searchEDate.value = "";
      searchSDate.value = "";
      const myInput = (this as any).$refs?.myInput;
      if (myInput) myInput.dateRange = {};
      getData();
    }

    // Fetch ads data
    async function FetchAds() {
      try {
        const response = await api.get("/api/auth/client/show_ads");
        adsData.value = response.data || [];
      } catch (error) {
        // error.value = true;
        console.error(error);
      }
    }

    // Open parcels list in a new tab
    function ToParcels(s: string, e: string, id: string) {
      const routeData = (this as any).$router.resolve({
        name: "list_coli",
        params: { status: s, etat: e, id },
      });
      window.open(routeData.href, "_blank");
    }

    // Toggle modal visibility
    function showDetails() {
      modal_show.value = !modal_show.value;
    }

    // Edit RIB information
    // async function EditRib() {
    //   // You need to define SubmitForm and Bank as refs and bind them to your form and bank selector
    //   const SubmitForm = (this as any).$refs?.SubmitForm;
    //   const Bank = bank.value;
    //   if (SubmitForm) {
    //   const success = await SubmitForm.validate();
    //   if (success && Object.keys(Bank).length !== 0) {
    //     const formData = new FormData();
    //     formData.append('rib', rib.value);
    //     formData.append('bank', Bank.id);
    //     formData.append('bank_name', Bank.name);
    //     formData.append('market', JSON.parse(localStorage.getItem('st') || '{}').id);
    //     try {
    //     const res = await api.post('/api/auth/client/add_Rib', formData);
    //     // load.value = false; // If you use a loader for this
    //     if (res.data.message === 'success') {
    //       // Show success toast
    //       // You need to implement your toast logic here
    //       // Fetch updated RIB status
    //       const ribRes = await api.get('/api/auth/client/checkRib', {
    //       params: { st: JSON.parse(localStorage.getItem('st') || '{}').id },
    //       });
    //       sow_rib.value = ribRes.data.data;
    //       modal_show.value = !modal_show.value;
    //     } else if (res.data.message === 'error form') {
    //       // Show error toast for incorrect RIB format
    //     } else if (res.data.message === 'required inputs') {
    //       // Show error toast for missing required fields
    //     } else if (res.data.message === 'error code') {
    //       // Show error toast for RIB code mismatch
    //     } else if (res.data.message === 'no bank') {
    //       // Show error toast for no matching bank
    //     }
    //     } catch (err) {
    //     // Show error alert
    //     }
    //   } else {
    //     // Show error alert for missing fields
    //   }
    //   }
    // }

    function sum(a, b) {
      return parseFloat(a) + parseFloat(b);
    }
    function percent(a, b, total) {
      if (
        a !== null &&
        a !== undefined &&
        b !== null &&
        b !== undefined &&
        total !== null &&
        total !== undefined &&
        total !== 0
      ) {
        const somme = sum(a, b) / parseFloat(total);
        return somme * 100;
      }
      return 0;
    }
    return {
      handleLogin,
      dashData,
      perms,
      searchEDate,
      searchSDate,
      adsData,
      visibleAds,
      dismissAd,
      adsIcon,
      sow_rib,
      modal_show,
      bankList,
      bank,
      rib,
      devise,
      isLoader,
      dataparcels,
      sum,
      percent,
    };
  },
});
</script>

<style scoped>
.notice-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notice-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #edeff5;
  border-left: 4px solid var(--notice-accent, #6560f0);
  border-radius: 8px;
  padding: 14px 18px;
  box-shadow: 0 2px 6px rgba(20, 20, 43, 0.04);
}

.notice-card-success {
  --notice-accent: #00b69b;
}
.notice-card-danger {
  --notice-accent: #f93c65;
}
.notice-card-warning {
  --notice-accent: #ffa756;
}
.notice-card-info,
.notice-card-primary {
  --notice-accent: #6560f0;
}

.notice-card-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--notice-accent, #6560f0) 14%, #fff);
  color: var(--notice-accent, #6560f0);
  font-size: 16px;
}

.notice-card-body {
  flex: 1 1 auto;
  font-size: 14px;
  color: #1e2022;
}

.notice-card-body :deep(p) {
  margin: 0;
}

.notice-card-close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #98a0ac;
  font-size: 12px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.notice-card-close:hover {
  color: #1e2022;
}

.notice-fade-enter-active,
.notice-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.notice-fade-enter-from,
.notice-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>